import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 text-center italic">(malnova angla kanto «Verdaj manikoj»)</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Amato mia forgesis min, <br/>
        Kaj kulpas pri tio kuranta roj’; <br/>
        Rigardis li al strifluoj sub pin’ <br/>
        Kaj sorĉis lin akva voj’. <br/>
        Ja ĉiuj scias – perfidos ĝi, <br/>
        Kaj ne revenos la vagabond’, <br/>
        Li iros ĉiam post hela vizi’ <br/>
        Kaj foriros el nia mond’.
      </p>

      <p class="poem-block mb-3">
        Diru al mi, kuranta roj’, <br/>
        Dum jaroj kuris vi ĝis montar’. <br/>
        Ĉu vere mi en neniu foj’ <br/>
        Lin ekvidos, kaj daŭros separ’? <br/>
        Mi ĵetos al akvo florkronon do, <br/>
        Atingu lin, revenigu lin! <br/>
        Ne diru, ke mi ĉagreniĝis tro, <br/>
        Diru, ke ridis, sendinte vin.
      </p>

      <p class="poem-block mb-3">
        Sed ne rapidu nur vi, esper’, <br/>
        Forlasi min, adiaŭi min. <br/>
        Ni kune aŭskultos sub nokta aler’ <br/>
        De l’ akvo konstantan «tin-tin’». <br/>
        Kaj viv’ forfluos kun akva stri’, <br/>
        Nebul’ sin sternos sur bord’. <br/>
        Reveni povos nek li, nek mi, <br/>
        Nur tintos striflua kord’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Greensleeves'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;